<template>
    <v-autocomplete
        v-model="idFacturadores"
        clearable
        variant="solo"
        :items="facturadores"
        :item-title="facturadorTitle"
        item-value="id"
        density="compact"
        hide-details
        multiple
        label="Facturador"
        :loading="cargandoFacturadores"
        @update:model-value="actualizarFacturadores"
    ></v-autocomplete>
</template>
<style src="../assets/base.css"></style>
<script>
    import AuthService from '@/api/AuthService';
    import FacturadorService from '@/api/FacturadorService';

    const authService = new AuthService();
    const facturadorService = new FacturadorService();

    export default {
        data() {
            return {
                idFacturadores: [],
                facturadores: [],
                cargandoFacturadores: false,
            }
        },
        async mounted(){
            await this.getFacturadores();
        },
        methods: {
            async getFacturadores(){
                this.cargandoFacturadores = true;
                let usuNivEst = await authService.getUsuarioNivelFacturador(localStorage.getItem("jwt"));

                this.facturadores = await facturadorService.getEstablecimientosUsuario(usuNivEst);
                    
                this.cargandoFacturadores = false;
            },
            facturadorTitle(item){
                if (!item) return '';
                return `${item.cuitFacturador} - ${item.nombre}`;
            },
            actualizarFacturadores(){
                this.$emit('update:idFacturadores', this.idFacturadores);
            }
        }
    }
</script>